__turbopack_context__.v({
  "className": "outfit_b541d203-module__Ev4enW__className",
});
